 // import Swiper JS
 import Swiper, { EffectFade, Navigation, Pagination, Autoplay } from 'swiper'
 // import Swiper styles
 import 'swiper/css';
 import 'swiper/css/effect-fade';
 import 'swiper/css/navigation';
 import 'swiper/css/pagination';
 

 const GENERAL_PROPS = {
    grabCursor: true,
    loop: true,
    speed: 3000,
  }


  const FADE_PROPS = {
    effect: 'fade',
    loop: true,
    speed: 500,
  }
  const CAROUSEL_PROPS = {
    loop: true,
    speed: 500,
  }

  const swiperADAduplicatedProcess = (currentSwiper) => {
		currentSwiper.slides.forEach((slide) => {
			if (slide.classList.contains('swiper-slide-duplicate')) {
				slide.setAttribute('aria-hidden', true);
				slide.setAttribute('tabindex', '-1');

				// REMOVE IDs
				slide.querySelectorAll('[id]').forEach((elementWithID) => {
					elementWithID.setAttribute('id', '');
				});

				// SET TABINDEXs -1
				slide.querySelectorAll('a').forEach((elementWithID) => {
					elementWithID.setAttribute('tabindex', '-1');
				});
			}
		});

		currentSwiper.el.querySelectorAll('.swiper-slide .swiper-pagination-bullet').forEach((dotInSlide) => {
			dotInSlide.setAttribute('tabindex', '-1');
		});
	};


// BG IMAGES SLIDER
document.querySelectorAll('.background-quad').forEach(quad => {
    const sliderPrev = quad.querySelector('.swiper-prev');
    const sliderNext = quad.querySelector('.swiper-next');
    const slider = quad.querySelector('.js-swiper');

    new Swiper(slider, {
      modules: [ EffectFade, Navigation, Autoplay ],
      ...GENERAL_PROPS,
      speed: 400,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      autoplay: {
        delay: 6000
      },
      navigation: {
        prevEl: sliderPrev,
        nextEl: sliderNext,
      },
      on: {
        init: function (currentSwiper) {
          swiperADAduplicatedProcess(currentSwiper);
          // updateLinkedGotos(currentSwiper.realIndex, slider);
        },
        slideChange : function (currentSwiper) {
          // updateLinkedGotos(currentSwiper.realIndex, slider);
        },

      },
    });
});



// LIST IMAGES SWIPER
document.querySelectorAll('.listMod_image').forEach(slider => {
    let sliderPrev = slider.querySelector('.swiper-prev');
    let sliderNext = slider.querySelector('.swiper-next');

    new Swiper(slider, {
      modules: [ EffectFade, Navigation, Autoplay ],
      ...GENERAL_PROPS,
      speed: 400,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      autoplay: {
        delay: 3400
      },
      navigation: {
        prevEl: sliderPrev,
        nextEl: sliderNext,
      },
      on: {
        init: function (currentSwiper) {
          swiperADAduplicatedProcess(currentSwiper);
          updateLinkedGotos(currentSwiper.realIndex, slider);
        },
        slideChange : function (currentSwiper) {
          updateLinkedGotos(currentSwiper.realIndex, slider);
        },

      },
    });
});


// Default swiper 
if(document.getElementsByClassName('top-swiper').length > 0){
  document.querySelectorAll('.top-swiper').forEach(slider => {

      let sliderPrev = document.querySelector('.top-content .swiper-prev');
      let sliderNext = document.querySelector('.top-content .swiper-next');

      new Swiper(slider, {
          modules: [ EffectFade, Navigation, Autoplay ],
          ...GENERAL_PROPS,
          speed: 400,
          effect: 'fade',
          fadeEffect: {
            crossFade: true,
          },
          autoplay: {
            delay: 3400
          },
          navigation: {
              prevEl: sliderPrev,
              nextEl: sliderNext,
          },
          on: {
            init: function (currentSwiper) {
              swiperADAduplicatedProcess(currentSwiper);
              updateLinkedGotos(currentSwiper.realIndex, slider);
            },
            slideChange : function (currentSwiper) {
              updateLinkedGotos(currentSwiper.realIndex, slider);
            },

          },
        })

  });
}
//slider Fade
if(document.querySelectorAll('[data-js-swiper="slider"]').length > 0){
  document.querySelectorAll('[data-js-swiper="slider"]').forEach(slider => {
      let sliderPrev = slider.getElementsByClassName('swiper-prev')[0];
      let sliderNext = slider.getElementsByClassName('swiper-next')[0];

      const sliderAutoplay = parseFloat(slider.dataset.autoplay) * 1e3 || 0;

      new Swiper(slider, {
          modules: [EffectFade, Navigation,Autoplay],
          ...FADE_PROPS,
          autoHeight: slider.classList.contains('js-mobile-autoheight'),
          fadeEffect: {
            crossFade: true,
          },
          navigation: {
              nextEl: sliderNext,
              prevEl: sliderPrev,
          },
          autoplay: sliderAutoplay < 1 ? false : { delay: sliderAutoplay },
          on: {
            init: function (currentSwiper) {
              swiperADAduplicatedProcess(currentSwiper);
              updateLinkedGotos(currentSwiper.realIndex, slider);
            },
            slideChange : function (currentSwiper) {
              updateLinkedGotos(currentSwiper.realIndex, slider);
            },

          },

        })

  });
}
//Carousel slider
if(document.querySelectorAll('[data-js-swiper="carousel"]').length > 0){
  document.querySelectorAll('[data-js-swiper="carousel"]').forEach(slider => {

      let numberSlides = slider.getAttribute('data-carousel') !== undefined ? parseInt(slider.getAttribute('data-carousel')) : 3;

      let centerMode = numberSlides % 2 === 0 ? false : true;
  

      let sliderPrev = slider.getElementsByClassName('swiper-prev')[0] || slider.parentElement.querySelector('.swiper-prev');
      let sliderNext = slider.getElementsByClassName('swiper-next')[0] || slider.parentElement.querySelector('.swiper-next');

      new Swiper(slider, {
          modules: [EffectFade, Navigation,Autoplay],
          ...CAROUSEL_PROPS,
          slidesPerView:numberSlides,
          centeredSlides:centerMode,
          fadeEffect: {
            crossFade: true,
          },
          navigation: {
              nextEl: sliderNext,
              prevEl: sliderPrev,
          },
          on: {
            init: function (currentSwiper) {
              swiperADAduplicatedProcess(currentSwiper);
              updateLinkedGotos(currentSwiper.realIndex, slider);
            },
            slideChange : function (currentSwiper) {
              updateLinkedGotos(currentSwiper.realIndex, slider);
            },

          },

        })

  });
}
//Carousel slider
if(document.querySelectorAll('[data-js-swiper="bigCarousel"]').length > 0){
  document.querySelectorAll('[data-js-swiper="bigCarousel"]').forEach(slider => {

      let sliderPrev = slider.getElementsByClassName('swiper-prev')[0];
      let sliderNext = slider.getElementsByClassName('swiper-next')[0];

      const dataLoop = slider.dataset.loop === 'yes';

      new Swiper(slider, {
          modules: [EffectFade, Navigation],
          ...CAROUSEL_PROPS,
          loop: dataLoop,
          slidesPerView: 1,
          spaceBetween: 0,
          centeredSlides: true,
          navigation: {
              nextEl: sliderNext,
              prevEl: sliderPrev,
          },
          breakpoints: {
            1200: {
              slidesPerView: 1.8,
            }
          },
          on: {
            init: function (currentSwiper) {
              swiperADAduplicatedProcess(currentSwiper);
              updateLinkedGotos(currentSwiper.realIndex, slider);
            },
            slideChange : function (currentSwiper) {
              updateLinkedGotos(currentSwiper.realIndex, slider);
            },
          },

        })

  });
}

/**
 * swiper custom dots
 */
document.querySelectorAll('.js-swiper-bullet').forEach((item) => {
  const target = item.dataset.goto ? parseInt(item.dataset.goto) : 0;
  const slider = item.dataset.target ? document.querySelector(item.dataset.target) : item.closest('.swiper');

  item.addEventListener('click', () => {
    if (slider.swiper.params.loop) {
      slider.swiper.slideToLoop(target);
    } else {
      slider.swiper.slideTo(target);
    }

    item.parentNode.querySelectorAll('.js-swiper-bullet').forEach((itm) => itm.classList.remove('js-swiper_active'));
    item.classList.add('js-swiper_active');
  });
});

function updateLinkedGotos(index, slider) {
  const gotosBySlider = [...document.querySelectorAll('.js-swiper-bullet')].filter((btn) => {
    const btnSlider = btn.dataset.target ? document.querySelector(btn.dataset.target) : btn.closest('.swiper');
    return btnSlider === slider;
  });

  
  gotosBySlider.forEach((item) => {
    item.classList.toggle('js-swiper_active', parseInt(item.dataset.goto) === index);
  });
}
